/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_TitleInputs */

const en_error_title = /** @type {(inputs: Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This page could not load.`)
};

/** @type {(inputs: Error_TitleInputs) => LocalizedString} */
const ar_error_title = en_error_title;

/** @type {(inputs: Error_TitleInputs) => LocalizedString} */
const he_error_title = en_error_title;

/** @type {(inputs: Error_TitleInputs) => LocalizedString} */
const ur_error_title = en_error_title;

/** @type {(inputs: Error_TitleInputs) => LocalizedString} */
const es_error_title = en_error_title;

/** @type {(inputs: Error_TitleInputs) => LocalizedString} */
const fr_error_title = en_error_title;

/** @type {(inputs: Error_TitleInputs) => LocalizedString} */
const de_error_title = en_error_title;

/** @type {(inputs: Error_TitleInputs) => LocalizedString} */
const pt_error_title = en_error_title;

/** @type {(inputs: Error_TitleInputs) => LocalizedString} */
const hi_error_title = en_error_title;

/** @type {(inputs: Error_TitleInputs) => LocalizedString} */
const bn_error_title = en_error_title;

/**
* | output |
* | --- |
* | "This page could not load." |
*
* @param {Error_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const error_title = /** @type {((inputs?: Error_TitleInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_TitleInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_error_title(inputs)
	if (locale === "he") return he_error_title(inputs)
	if (locale === "ur") return ur_error_title(inputs)
	if (locale === "es") return es_error_title(inputs)
	if (locale === "fr") return fr_error_title(inputs)
	if (locale === "de") return de_error_title(inputs)
	if (locale === "pt") return pt_error_title(inputs)
	if (locale === "hi") return hi_error_title(inputs)
	if (locale === "bn") return bn_error_title(inputs)
	return /** @type {LocalizedString} */ ("This page could not load.")
});